/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-07 15:44:30
 * @LastEditors: caiqin.xie
 * @message: 左侧列表组件
 */
import React from "react";
import BlogItem from "../BlogItem";
import BlogList from "../BlogList";
import { IBlogItem } from '../../../../../common/types'
import styles from "../../index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  device: string;
  pageNum: number; // 当前页码
  blogList: IBlogItem[]; // 博客列表
  allBlogList: IBlogItem[]; // 所有博客列表
  hostBanner: Record<string, any>; // 主机banner
  gameBanner: Record<string, any>; // 游戏banner
  recommendBlogList: IBlogItem[]; // 推荐博客列表
}

const LeftList = (props:IProps) => {
  const {ctry, words, pageNum, device, blogList, allBlogList, hostBanner, gameBanner, recommendBlogList} = props

  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  // 渲染pc第二页及以后
  const renderPcSecondPage = () => {
    return blogList && blogList.map((item, index) => (
      <a
        href={`/${ctry}/blog/${item.seoUrl}`}
        key={item.id}
        className={styles['link-blog']}>
        <BlogItem
          type='normal'
          blogData={item}
          className={styles['custom-blog']}
          picClassName={styles['custom-blog-pic']}
          itemClassName={styles['custom-blog-item']} />
      </a>
    ))
  }

  // 渲染pc
  const renderPc = () => {
    if (pageNum === 1) {
      // pc 第一页
      return (
        <BlogList
          blogList={blogList}
          recommendBlogList={recommendBlogList}
          hostBanner={hostBanner}
          gameBanner={gameBanner}
          ctry={ctry}
          words={words} />
      )
    } else {
      // pc 第二页及以后
      return renderPcSecondPage()
    }
  }

  // 渲染移动
  const renderMobile = () => {
    return (
      <BlogList
        blogList={allBlogList}
        recommendBlogList={recommendBlogList}
        hostBanner={hostBanner}
        gameBanner={gameBanner}
        ctry={ctry}
        words={words} />
    )
  }

  // 渲染blog
  const renderBlog = () => {
    if (newDevice === 'pc') {
      return renderPc()
    } else {
      return renderMobile()
    }
  }

  return (
    <>
      {/* 渲染blog列表 */}
      {renderBlog()}
    </>
  )
}
export default LeftList
